import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class ColorConfiguration {
    /**
     * The alpha value. This value can be any number between `0` and `1` and represents the opacity of the Color.
     * `0` indicates the color is fully transparent and `1` indicates it is fully opaque.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Color.html#a)
     */
    @JsonProperty()
    declare a: number;

    /**
     * The blue value. This value can range between `0` and `255`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Color.html#b)
     */
    @JsonProperty()
    declare b: number;

    /**
     * The green value. This value can range between `0` and `255`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Color.html#g)
     */
    @JsonProperty()
    declare g: number;

    /**
     * The red value. This value can range between `0` and `255`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Color.html#r)
     */
    @JsonProperty()
    declare r: number;

    constructor() {}
}

@JsonObject()
export class ColorBackgroundConfiguration {
    /**
     * The color of the background.
     *
     * @default black
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-webmap-background-ColorBackground.html#color)
     */
    @JsonProperty()
    declare color: ColorConfiguration | undefined;
    /**
     * For ColorBackground the type is always `color`.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-webmap-background-ColorBackground.html#type)
     */
    @JsonProperty()
    declare readonly type: string;

    constructor() {}
}
